import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import { api } from './api'
import * as actions from './actions'

const fetchOAuthCodeEpic = (action$) => {
  return action$
    .ofType(actions.fetchOAuthCode.toString())
    .pluck('payload')
    .switchMap(({ redirect_uri, client_id }) => {
      return Observable.fromPromise(api.fetchOAuthCode({ redirect_uri, client_id }))
        .map((response) => actions.fetchOAuthCodeSuccess({ redirect_uri, client_id, code: response.code }))
        .startWith(actions.fetchOAuthCodePending({ client_id }))
        .catch(error => {
          return Observable.of(actions.fetchOAuthCodeFailed({ error, client_id }))
        })
    })
}

const fetchOAuthAppInfoEpic = (action$) => {
  return action$
    .ofType(actions.fetchOAuthAppInfo.toString())
    .pluck('payload')
    .switchMap(({ client_id }) => {
      return api
        .fetchOAuthAppInfo({ client_id })
        .map((response) => actions.fetchOAuthAppInfoSuccess({ client_id, app: response }))
        .startWith(actions.fetchOAuthAppInfoPending({ client_id }))
        .catch(error => {
          return Observable.of(actions.fetchOAuthAppInfoFailed({ error, client_id }))
        })
    })
}

export const epic = combineEpics(
  fetchOAuthCodeEpic,
  fetchOAuthAppInfoEpic
)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/epic.js